import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`;

export default function NavBar({ children }) {
  return <Container>{children}</Container>;
}



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js